import * as actionTypes from "./actionTypes";
import initialState from "reducers/initialState";

const globalParamsReducer = (state = initialState.params, action) => {
  switch (action.type) {
    case actionTypes.LOAD_GLOBAL_PARAMS_STARTED: {
      return {
        ...state,
        loading: true
      };
    }

    case actionTypes.LOAD_GLOBAL_PARAMS_SUCCESS:
      return {
        ...action.payload,
        loading: false,
        loaded: true
      };

    case actionTypes.INVALIDATE_GLOBAL_PARAMS:
      return {
        ...state,
        loading: false,
        loaded: false
      };

    default:
      return state;
  }
};

export default globalParamsReducer;
